<template>
    <div class="container container-noticies-block">
        <div class="row">
            <div class="col-12 col-lg-4">
                <div class="row">
                    <div class="col-12">
                        <div class="container-title container-title--blue">
                            <p>Últimas notícias</p>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="noticia in ultimas" :key="noticia.id">
                    <div class="col-12">
                        <router-link :to="noticia.url" target="_self" class="noticies-item noticies-item--nofloat">
                            <div class="noticies-item--image">
                                <img v-if="noticia.image" :src="utils.image(noticia.image, 160, 104)" alt="">
                                <img v-else src="@/assets/images/search-placeholder.jpg" />
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticia.hat || noticia.editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticia.title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="row">
                    <div class="col-12">
                        <div class="container-title container-title--blue">
                            <p>Vídeos mais vistos</p>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="video in vistos" :key="video.id">
                    <div class="col-12">
                        <router-link :to="video.url" target="_self" class="noticies-item noticies-item--nofloat">
                            <div class="noticies-item--image">
                                <img v-if="video.video && video.video.thumbnail" :src="utils.image(video.video.thumbnail, 160, 104)" alt="">
                                <img v-else src="@/assets/images/search-placeholder.jpg" />
                                <div class="noticies-item__play"></div>
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{video.hat}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{video.title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-4">
                <div class="row">
                    <div class="col-12">
                        <div class="container-title container-title--blue">
                            <p>Mais lidas</p>
                        </div>
                    </div>
                </div>
                <div class="row" v-for="(noticia, key) in lidas" :key="noticia.id">
                    <div class="col-12">
                        <router-link :to="noticia.url" target="_self" class="noticies-item noticies-item--nofloat">
                            <div class="noticies-item--image">
                                <img v-if="noticia.image" :src="utils.image(noticia.image, 160, 104)" alt="">
                                <img v-else src="@/assets/images/search-placeholder.jpg" />
                                <div class="noticies-item__badge">0{{key+1}}</div>
                            </div>
                            <div class="noticies-item--info">
                                <p class="noticies__label"><strong>{{noticia.hat || noticia.editorial.title}}</strong></p>
                                <p class="noticies__title noticies__title--white"><strong>{{noticia.title}}</strong></p>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import utils from '@/utils'

import home from '@/store/home'

export default {
    name: 'Listas',
    data: function() {
        return {
            vistos:[],
            lidas:[],
            utils:utils,
        }
    },
    computed:{
        ultimas: function() {
            return home.getters.ultimas
        }
    },
    methods:{
        async getUltimas() {
            let now = new Date()
            if (home.state.ultimas_expires_at && home.state.ultimas_expires_at < now) {
                await home.dispatch('getUltimas')
            }
        },
        async getVistos() {
            const response = await api.get('ranking/', {
                type:'videos.VideoPage', 
                fields:'url,hat,video',
                order:'clicks',
                limit:'4'
            })
            if(response.ok) {
                this.vistos = response.data.items
            }
        },
        async getLidos() {
            const response = await api.get('ranking/', {
                type:'news.NewsPage', 
                fields:'editorial,url,image,hat',
                order:'clicks',
                limit:'4'
            })
            if(response.ok) {
                this.lidas = response.data.items
            }
        }
    },
    mounted() {
        this.getUltimas()
        this.getVistos()
        this.getLidos()
    }
}
</script>